import * as React from 'react';

const Up = ({ ...props }) => (
    <svg
        width="16"
        height="24"
        viewBox="0 0 16 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
    >
        <path
            d="M14 12.4382L8.65217 7.5L8.65217 19L7.32609 19L7.32609 7.5L2 12.4382L2 10.6427L8 5L14 10.6427L14 12.4382Z"
            fill="currentColor"
        />
    </svg>
);

export default Up;
